export const Context = {
  Home: "HOME",
  Map: "MAP",
  Graph: "GRAPH",
  GraphIntra: "GRAPH_INTRA",
  Policy: "POLICY",
  Trade: "TRADE",
  Mobility: "MOBILITY"
}
